export const PopupTypes = {
  Help: 'Help',
  Fairness: 'Fairness',
  CheckHash: 'CheckHash',
  SlowConnection: 'SlowConnection',
  Reconnect: 'Reconnect',
  ConnectionError: 'ConnectionError',
};
